module.exports = __webpack_public_path__ + "first-50-glossy_number.jpg?1ae8c894409468986f8dca77c6d7bf49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50-glossy_number.jpg
// module id = 526
// module chunks = 0